<template>
  <span v-if="generalConfig">
    <BotPageTitle />
    <div style="width: 100%">
      <div v-if="govbrTenants.includes(tenant)"  class="columnWidth">
        <GovBrAuth :canalWebData="generalConfig.webclientChannels[selectedProfile].config" />
      </div>
       <div v-if="magentoTenants.includes(tenant)" class="columnWidth">
        <MagentoAuth :canalWebData="generalConfig.webclientChannels[selectedProfile].config" />
      </div>
    </div>

    <div class="md-layout">
      <div class="md-layout-item">
        <md-button
          class="md-button md-success md-theme-default"
          style="display: block; margin-left: auto; margin-right: auto;"
          @click="saveActionDialog('save')"
        >
          <span style="color: black">{{ $t("commonWords.save") }}</span>
        </md-button>
      </div>
    </div>
  </span>
</template>

<script>
import Swal from 'sweetalert2'
import { mapFields } from 'vuex-map-fields'
import GovBrAuth from '@/components/Settings/CanalWeb/GovBrAuth.vue'
import MagentoAuth from '@/components/Settings/CanalWeb/MagentoAuth.vue'
import isTenantMixin from '@/components/mixins/isTenantMixin'
import BotPageTitle from '@/components/BotPageTitle'

export default {
  components: { BotPageTitle, GovBrAuth, MagentoAuth },
  methods: {
    async saveActionDialog (type) {
      if (type === 'cancel') {
        let aux = this.selectedProfile
        this.selectedProfile = this.oldSelectedProfile
        this.oldSelectedProfile = aux
      } else if (type === 'dont-save') {
        Swal.fire({
          icon: 'error',
          title: this.$t('auth.changesWereNotSaved')
        })
        this.generalConfig.webclientChannels[this.oldSelectedProfile] = this.canalWebBackUp
        this.updateBackup()
        this.modified = false
      } else if (type === 'save') {
        await this.saveData(this.selectedProfile, 'save')
        this.modified = false
        Swal.fire({
          icon: 'success',
          title: this.$t('auth.changesHaveBeenSaved')
        })
        this.updateBackup()
      }
      this.saveDataDialog = false
    },
    updateBackup () {
      this.canalWebBackUp = JSON.parse(
        JSON.stringify(
          this.generalConfig.webclientChannels[this.selectedProfile]
        )
      )
    },
    requiredFieldsError () {
      Swal.fire({
        icon: 'error',
        title: this.$t('auth.fillInTheMandatoryFields')
      })
    },
    async saveData (index, type) {
      let save = true
      // id dos itens do array removidos/alterados
      if (type === 'save') {
        if (this.idleWarningMessage || this.idleTerminationMessage || this.idleTerminationTime || this.idleWarningTime) {
          this.requiredFieldsError()
          save = false
        } else {
          this.loading = true
          this.deletedConfigID = null
          this.savedConfigID = this.generalConfig.webclientChannels[index].id
        }
      } else if (type === 'delete') {
        this.loading = true
        this.savedConfigID = null
        this.deletedConfigID = this.generalConfig.webclientChannels[index].id
        this.generalConfig.webclientChannels.splice(index, 1)
        this.generalConfig.webclientChannels = [...this.generalConfig.webclientChannels]
      }
      if (save) {
        await this.$axios.put(`/assistant-configs/${this.assistantId}`, this.generalConfig)
          .then((response) => {
            this.loading = false
            this.$vuetify.goTo(0)
          })
          .catch(error => {
            Swal.fire({
              icon: 'error',
              title: this.$t('auth.error'),
              html: `${this.$t('auth.unableToSaveWizardSettings')} <br> ${error}`
            })
          })
      }
    }
  },
  watch: {
    selectedProfile (nV, oV) {
      this.oldSelectedProfile = oV
    }
  },
  created: function () {
    if (typeof this.assistantId === typeof null) {
      Swal.fire({
        text: this.$t('auth.selectACognitiveAssistant'),
        icon: 'warning',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'OK'
      })
      this.$router.push('/lista-assistentes')
    }
  },
  async mounted () {
    if (typeof this.assistantId !== typeof null) {
      this.$axios
        .get(`/assistant-configs/${this.assistantId}`)
        .then((response) => {
          this.generalConfig = response.data
          this.updateBackup()
          this.oldSelectedProfile = 0
        })
        .catch((error) => {
          Swal.fire({
            icon: 'error',
            title: this.$t('auth.error'),
            html: `${this.$t('auth.couldNotAccessWizardSettings')} <br> ${error}`
          })
        })
      this.loading = false
    }
  },
  mixins: [isTenantMixin],
  computed: {
    ...mapFields('webChannel', ['modified']),
    ...mapFields('selectedAssistant', ['assistantId'])
  },
  data () {
    return {
      govbrTenants: ['inss', 'demo', 'dataprev', 'sefmg'],
      magentoTenants: ['yaracst', 'demo'],
      tenant: '',
      loading: true,
      selectedProfile: 0,
      oldSelectedProfile: null,
      saveDataDialog: false,
      canalWebBackUp: null,
      chipGpKey: 0,
      generalConfig: null
    }
  }
}
</script>

<style >
.columnWidth {
  float: left;
  width: 50%;
}
@media (max-width: 1239px) {
  .columnWidth {
    float: left;
    width: 100%;
  }
}
</style>
